// GENERATED from ez-tree preset "Pine Medium" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const PineMedium_KIND_ID = "ezTree_PineMedium";

export const PineMediumKind = new SceneryKindDef({
	id: "ezTree_PineMedium",
	name: "Pine Medium",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 1,
		"branchAngle1": 110,
		"branchAngle2": 16,
		"branchChildren0": 82,
		"branchChildren1": 3,
		"branchGnarliness0": 0.05,
		"branchGnarliness1": 0.08,
		"branchGnarliness2": 0,
		"branchGnarliness3": 0,
		"branchLength0": 50,
		"branchLength1": 23.87,
		"branchLength2": 14.08,
		"branchRadius0": 1.05,
		"branchRadius1": 0.36,
		"branchStart1": 0.27,
		"branchStart2": 0.14,
		"treeType": "evergreen",
		"leafCount": 30,
		"leafSize": 1.435,
		"leafSizeVariance": 0.201,
		"leafAngle": 39,
		"leafStart": 0.09,
		"leafAlphaTest": 0.3,
		"leafType": "pine",
		"barkType": "Bark003",
		"forceStrength": -0.003,
		"targetHeight": 12.6,
	},
	footprintRadiusRatio: 0.334,
});
